exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-group{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:nowrap;flex-wrap:nowrap;padding-top:.5rem;margin-bottom:1.5rem}.btn-group>*{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.btn-group--horizontal .o-btn+.o-btn{margin-left:.5rem}", ""]);

// exports
